export class PreAuthenticationModel {
  statusCode: string;
  dataCollectorUrl: string;
  dataCollectorKey: string;
  userMessageTitle: string;
  userMessageDesc: string;
  dataErrorWithRetryBtn: boolean;
  
  constructor(
    statusCode: string, 
    dataCollectorUrl: string, 
    dataCollectorKey: string,
    userMessageTitle: string,
    userMessageDesc: string,
    dataErrorWithRetryBtn: boolean
  ) {
    this.statusCode = statusCode;
    this.dataCollectorUrl = dataCollectorUrl;
    this.dataCollectorKey = dataCollectorKey;
    this.userMessageTitle = userMessageTitle;
    this.userMessageDesc = userMessageDesc;
    this.dataErrorWithRetryBtn = dataErrorWithRetryBtn;
  }
}
